import AudioInputControl from "./AudioInputControl";
import AudioInputVFControl from "./AudioInputVFControl";
import { useAppState } from "@platform/features/video/providers/AppStateProvider";
import { VideoUIContainerBreakpoints } from "../../videoUI.types";

export type Props = {
  containerBreakpoints: VideoUIContainerBreakpoints;
};

export function VideoUIControlsAudioInputContainer({
  containerBreakpoints,
}: Props) {
  const { isWebAudioEnabled } = useAppState();

  return isWebAudioEnabled ? (
    <AudioInputVFControl containerBreakpoints={containerBreakpoints} />
  ) : (
    <AudioInputControl containerBreakpoints={containerBreakpoints} />
  );
}

export default VideoUIControlsAudioInputContainer;
